export const cardTypes = {
  mastercard: 'M',
  visa: 'V',
  amex: 'A',
  'diners-club': 'D',
  discover: 'R',
  jcb: 'J',
  unionpay: 'UP',
};
